import { AdminHealthDashboardPage } from '@/pages/admin/AdminHealthDashboardPage'
import { AdminOrganizationDetailPage } from '@/pages/admin/AdminOrganizationDetailPage'
import { useAuth } from '@/state/AuthContext'
import { getAdminLandingKind } from '@/lib/adminCapabilities'

export function AdminHomePage() {
  const { user } = useAuth()
  const landingKind = getAdminLandingKind(user?.attributes?.role)

  if (landingKind === 'platform') {
    return <AdminHealthDashboardPage />
  }

  return <AdminOrganizationDetailPage />
}
